<template>
  <div class="index">
    <div class="main-wrapper">
      <layout-header></layout-header>

      <layout-sidebar></layout-sidebar> 
      <keep-alive > 
        <router-view />
      </keep-alive>
    </div>

    <!-- /Page Wrapper -->
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/SidebarChatbot.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
  },
  mounted() {
    // this.$store.dispatch("aiKey/getLanguageStyle");
    console.log('mounted')
  },
};
</script>
 


// WEBPACK FOOTER //
// src/components/layouts/ChatbotConfigLayout.vue